import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

import { storage } from "../config/firebase";

export const uploadFileToFirebase = async (file, url) => {
  if (!file) return;

  const uniqueId = Date.now();
  const randomNum = Math.floor(Math.random() * 1000);
  const fileExtension = file?.type?.split("/")[1];

  const imageName = `${file?.name || uniqueId}_${randomNum}.${fileExtension}`;

  const imageRef = ref(storage, `${url || "images"}/${imageName}`);

  try {
    const snapshot = await uploadBytes(imageRef, file);
    const url = await getDownloadURL(snapshot.ref);
    return url;
  } catch (error) {
    console.error("Error uploading image to Firebase:", error);
  }
};

export const uploadAudioFileToFirebase = async (file) => {
  if (!file) return;

  const uniqueId = Date.now();
  const randomNum = Math.floor(Math.random() * 1000);
  const fileExtension = file?.type?.split("/")[1];

  const audioName = `${uniqueId}_${randomNum}.${fileExtension}`;

  const audioRef = ref(storage, `audio/${audioName}`);

  try {
    const snapshot = await uploadBytes(audioRef, file);
    const url = await getDownloadURL(snapshot.ref);
    return url;
  } catch (error) {
    console.error("Error uploading audio to Firebase:", error);
  }
};
